export function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[140px]">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
          {/* Text Content */}
          <div>
            <h2 className="text-3xl font-bold text-[#4D4D4D] mb-8">
              About WQData LIVE
            </h2>
            <div className="space-y-5">
              <p className="text-[#4D4D4D] text-lg leading-relaxed">
                WQData LIVE is a web-based service providing 24/7 access to remote environmental monitoring data. Telemetry-enabled data loggers collect and transmit sensor measurements at predefined schedules.
              </p>
              <p className="text-[#4D4D4D] text-lg leading-relaxed">
                Customizable dashboards reveal trends, monitor performance, support informed decision-making, and transform complex data into actionable intelligence. The platform enables water agencies and facility managers to apply statistical methods, helping us identify patterns, visualize trends, and make informed decisions.
              </p>
              <p className="text-[#4D4D4D] text-lg leading-relaxed">
                Reports consolidate, organize, analyze, and present data in clear, understandable formats with graphics, data tables and statistical summaries provide insights in SLDs for integration with other applications, and the API provides direct access to the database.
              </p>
            </div>
          </div>

          {/* Dashboard Mockup Image */}
          <div className="flex justify-center md:justify-end">
            <div className=" rounded-lg overflow-hidden">
              <img 
                src="/images/about.jpg" 
                alt="WQData LIVE Dashboard" 
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
